import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/products/copy")({
  component: lazyRouteComponent(() => import("./-pages/admin.products.copy")),
  head: () => ({
    meta: [
      { title: "مساعد صياغة منتج — LECMO Admin" },
      { name: "robots", content: "noindex,nofollow" },
    ],
  }),
});
